

const PromanNeeds = () =>{
    return (
        <>
        
        <div className="needsbg">
            <div className='container needcontent' >
                <h4 className='needhead' >Why You Need a Proman?</h4>
                <p className='needpara'>ProMan Cloud offers a transformative solution for manufacturing organizations aiming to achieve operational excellence, enhance productivity, and leverage data for strategic decisions.
                It allows for streamlined data flow and facilitates efficient communication between departments. 
                </p>
            </div>
        </div>
        </>
        );
}

export default PromanNeeds